{
  "copySuccess": "已复制",
  "downloadSuccess": "已下载",
  "downloadFailed": "无法下载",
  "serverError": "服务器异常，请稍候重试。",
  "refresh": "刷新",
  "operationTimedOut": "操作超时，请重试。",
  "noContent": "暂无内容",
  "returnHome": "返回首页",
  "setTransactionPassword": "请先设置交易密码",
  "setTransactionPasswordDescription": "请先设置交易密码以继续使用当前交易方式。",
  "gotIt": "知道了",
  "goToSettings": "去设置",
  "securityVerification": "安全验证",
  "confirm": "确认",
  "chooseFromLibrary": "从相册选择",
  "takePhoto": "拍照",
  "cancel": "取消",
  "chooseAnotherVideo": "选择其他视频",
  "startAppeal": "发起申诉",
  "amountMismatch": "金额不符",
  "complete": "完成",
  "invalidVideoFormat": "视频格式不符",
  "videoTooLarge": "视频大小超过了 200MB 的限制",
  "uploadVideoProof": "上传视频凭证",
  "videoUploadHint": "上传的视频不能超过200MB，支持 MP4、AVI、MOV。",
  "currentLevel": "当前等级",
  "levelValidUntil": "等级持续至",
  "depositAddressLoadFailed": "获取地址失败",
  "deposit": "收币",
  "depositNotice": "温馨提示",
  "depositNoticePrefix": "本地址与二维码仅支持",
  "depositNoticeSuffix": "收款，类型错误可能无法找回且网站不予赔付。请确认您所需的转币类型。",
  "allNotificationsRead": "已全部标记为已读",
  "notifications": "通知",
  "markAllRead": "全部已读",
  "noNotifications": "暂无通知",
  "settings": "设置",
  "language": "语言",
  "pricingCurrency": "计价币种",
  "appNotifications": "App系统通知",
  "devicePermissions": "设备权限",
  "notificationPermissionDescription": "一旦禁用，您将无法接收订单更新通知、客服信息通知。",
  "enabled": "已启用",
  "general": "通用",
  "scanToPay": "扫码支付",
  "unsupportedQrCode": "不支持的二维码",
  "scanQrCode": "扫描二维码",
  "scanQrFromLibrary": "从相册扫描二维码",
  "qrCodeNotFound": "找不到二维码",
  "photoLibrary": "相册",
  "cameraUnavailable": "无法使用相机",
  "cameraPermissionDescription": "相机权限未开启。你可以在「设置」中更改。",
  "invalidPaymentLink": "无效的支付链接",
  "scanToPayHint": "使用{{brand}}网页 App 扫描二维码完成支付",
  "paymentQrExpired": "支付二维码已过期",
  "signInToPayInBrowser": "在浏览器登入支付",
  "visitOfficialWebsite": "→进入{{brand}}官方网站",
  "approximate": "≈ {{amount}}",
  "version": "版本 {{version}}",
  "buildCommit": "构建提交",
  "clearInput": "清除输入内容",
  "showPassword": "显示密码",
  "hidePassword": "隐藏密码",
  "runtimeEnvironment": {
    "production": "生产环境",
    "staging": "预发布环境",
    "localhost": "本地开发环境"
  },
  "copying": "复制中",
  "copyFailed": "复制失败",
  "copy": "复制",
  "backendEnvironment": "后端环境",
  "environmentSwitchDescription": "切换环境会清除当前登录状态。",
  "tradingDisabled": "系统维护中，交易功能暂时停用，请稍候再试。",
  "diagnostics": {
    "cancelled": "已取消",
    "preparing": "准备中",
    "exportFailed": "导出失败",
    "save": "保存",
    "share": "分享",
    "saved": "已保存",
    "shared": "已打开分享",
    "title": "诊断日志",
    "exportLog": "导出诊断日志",
    "copyLog": "复制诊断日志",
    "androidDescription": "可复制最近日志，或保存完整文件",
    "iosDescription": "导出文件并发送给 {{brand}} 支持"
  },
  "languageName": {
    "zh-Hans": "简体中文",
    "zh-Hant": "繁體中文",
    "th-TH": "ไทย",
    "vi-VN": "Tiếng Việt"
  }
}
